import { render, staticRenderFns } from "./FloatingCamV2Widget.vue?vue&type=template&id=2872a1ca&scoped=true"
import script from "./FloatingCamV2Widget.vue?vue&type=script&lang=js"
export * from "./FloatingCamV2Widget.vue?vue&type=script&lang=js"
import style0 from "./FloatingCamV2Widget.vue?vue&type=style&index=0&id=2872a1ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2872a1ca",
  null
  
)

export default component.exports